import React from "react"
import "./styles.scss"
import checkLottie from "../../assets/icons/check-lottie.json"
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from "react-virtualized"
import { Input } from "../../components/Form"
import Lottie from "react-lottie"
import { Button, ButtonActions, ButtonReloadPage } from "../../components/Button"
import { Spinner } from "../../components/Loading"
import { FaAngleRight, FaWhatsapp } from "react-icons/fa6"
import { MdClose } from "react-icons/md"
import { isMobile } from "react-device-detect"
import { FarmerImportContainer } from "../../container/FarmerImportContainer"
import { useSelector } from "react-redux"

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 69,
})

const defaultLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: checkLottie,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
}

const MobileFormScreen = ({
  platformLogo,
  form,
  cachedAt,
  setForm,
  forms,
  users,
  setUser,
  user,
  handleClick,
  search,
  handleSearhTerm,
  goToHome,
  goBack,
  isLoading,
  reload,
  goToAddBeneficiary,
  addBeneficiary,
  error,
  setAddBeneficiary
}) => {

  const online = useSelector(state => state.app.online)
  console.log(cachedAt)

  const Row = ({ index, key, parent, style }) => {
    const row = users[index]

    return (
      <>
        {isMobile ? (
          <CellMeasurer cache={cache} columnIndex={0} key={key} rowIndex={index} parent={parent}>
            <div
              style={{
                ...style,
                // top: `${10 + index * 70}px !important`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="form-row"
              onClick={() => setUser(row)}>
              <div>
                <img
                  className="form-image"
                  src={
                    row?.image
                      ? row.image
                      : `https://ui-avatars.com/api/?background=random&name=${row.name}`
                  }
                />
                <div className="form-user-info">
                  {row.name !== "" || null ? (
                    <span>
                      <text className="form-user-name">{truncateString(row.name)}</text>
                    </span>
                  ) : (
                    <></>
                  )}
                  {row.whatsapp !== "" || null ? (
                    <span className="form-whatsapp">
                      <div className="whatsapp-icon">
                        <FaWhatsapp />
                      </div>{" "}
                      {row.whatsapp}
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <FaAngleRight />
            </div>
          </CellMeasurer>
        ) : (
          <CellMeasurer cache={cache} columnIndex={0} key={key} rowIndex={index} parent={parent}>
            <div
              style={{ ...style }}
              className={`form-row ${index % 2 ? "even" : "odd"}`}
              onClick={() => setUser(row)}>
              <span>{row.name}</span>
            </div>
          </CellMeasurer>
        )}
      </>
    )
  }

  function verificarEntrada(input) {
    const regexTelefone = /^\(?\d{2}\)?[\s-]?\d{4,5}[-]?\d{4}$/;
    const regexSemNumeros = /^[^0-9]+$/;

    if (regexTelefone.test(input)) {
      return "number";
    } else if (regexSemNumeros.test(input)) {
      return "string";
    }
  }


  const EmptyRow = () => {
    const isPhoneNumber = verificarEntrada(search) === 'number';

    return (
      <div className="form-list">
        {isMobile && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            className="form-row"
            onClick={isPhoneNumber ? () => { setUser({ phone: search }); goToAddBeneficiary() } : null}
          >
            <div>
              {isPhoneNumber && (
                <img
                  className="form-image"
                  src="https://ui-avatars.com/api/?background=random&name=beneficiário"
                  alt="Beneficiário"
                />
              )}
              <div className="form-user-info">
                <span>
                  <text className="form-user-name">
                    {isPhoneNumber
                      ? 'Adicionar um novo usuário'
                      : 'Usuário não encontrado, digite um número de telefone'}
                  </text>
                </span>
                {isPhoneNumber && <span className="form-whatsapp">{search}</span>}
              </div>
            </div>
            {isPhoneNumber && <FaAngleRight />}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {isMobile ? (
        <>
          <div
            className={!form && !user ? "new-register-header" : !user ? "beneficiary-header" : ""}>
            <div className="form-header">
              <div style={{ display: "flex", gap: "10px" }}>
                <button className="button-back" onClick={goBack}>
                  <i className="fi fi-sr-arrow-small-left" />
                </button>
                <span>{!form && !user ? "Novo registro" : !user ? "Beneficiários" : ""}</span>
                {/* {form && !user ? (
              <button
                style={{
                  height: "30px",
                  width: "30px",
                  backgroundColor: "#f2f2f2",
                  borderRadius: "100%",
                }}
                className="button-back"
                onClick={handleBack}>
                <MdClose />
              </button>
            ) : (
              <></>
            )} */}
              </div>
            </div>
            {form && !user ? (
              <div style={{ padding: "0px 15px" }}>
                <Input
                  placeholder={"Pesquise pelo nome ou telefone"}
                  onChange={handleSearhTerm}
                  value={search || ""}
                  hasIcon={<i class="fi fi-rr-search"></i>}
                  hasFocus={false}
                // handleClick={handleClick}
                // iconClick="fi fi-rr-add"
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div
            className={
              !form && !user
                ? "form-container"
                : !user
                  ? "beneficiary-form-container"
                  : "form-container"
            }>
            <div className="form-header-title">
              <span className="header-text">
                {!form && !user
                  ? "Selecione o formulário que você deseja preencher"
                  : !user
                    ? "Selecione o(a) beneficiário(a)"
                    : ""}
              </span>
              {online && <ButtonReloadPage lastUpdated={cachedAt} isLoading={isLoading} reload={reload} />}
            </div>
            {!form ? (
              <>
                {error ? (
                  <></>
                ) : (
                  <div className="form-content">
                    {isLoading ? (
                      <div className="form-success">
                        <Spinner size="large" color="primary" />
                      </div>
                    ) : Array.isArray(forms) && forms?.length > 0 ? (
                      forms?.map((item) => (
                        <div className="form-card" key={item.id} onClick={() => setForm(item.id)}>
                          <span>
                            {item.title} <FaAngleRight />
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="form-empty">
                        <span>Não há dados</span>
                      </div>
                    )}
                  </div>
                )}
              </>
            ) : !user ? (
              <div className="form-content">
                {users.length > 0 ? (
                  <div
                    style={{
                      height: "100%",
                      width: "100%",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}>
                    <AutoSizer>
                      {({ height, width }) => (
                        <List
                          // ref={ref}
                          deferredMeasurementCache={cache}
                          height={height}
                          rowCount={users?.length}
                          rowHeight={cache._defaultHeight}
                          rowRenderer={Row}
                          width={width}
                          innerElementType="ul"
                          className="form-list"
                        />
                      )}
                    </AutoSizer>
                  </div>
                ) : search !== "" ? (
                  <EmptyRow />
                ) : (
                  <div className="form-empty">
                    <span>Não há dados</span>
                  </div>
                )}
              </div>
            ) : (
              <div className="form-success">
                <Spinner size="large" color="primary" />
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="form-container">
          <div className="form-header">
            <button className="button-back" onClick={goToHome}>
              <i className="fi fi-sr-arrow-small-left" />
            </button>
            <div className="form-logo" style={{ backgroundImage: `url(${platformLogo})` }}></div>
          </div>
          {!form ? (
            <div className="form-content">
              {forms?.map((item) => (
                <div className="form-card" key={item.id} onClick={() => setForm(item.id)}>
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          ) : !user ? (
            <div className="form-content">
              <Input
                placeholder={"Pesquise pelo nome ou telefone"}
                onChange={(e) => handleSearhTerm(e.target.value)}
                value={search || ""}
                hasIcon={<i class="fi fi-rr-search"></i>}
                isWhite
                hasFocus={false}
              // handleClick={handleClick}
              // iconClick="fi fi-rr-add"
              />
              {users.length > 0 ? (
                <div
                  style={{ height: "100%", width: "100%", overflowY: "auto", overflowX: "hidden" }}>
                  <AutoSizer>
                    {({ height, width }) => (
                      <List
                        // ref={ref}
                        deferredMeasurementCache={cache}
                        height={height}
                        rowCount={users?.length}
                        rowHeight={cache.rowHeight}
                        rowRenderer={Row}
                        width={width}
                        innerElementType="ul"
                        className="form-list"
                      />
                    )}
                  </AutoSizer>
                </div>
              ) : (
                <div className="form-empty">
                  <span>Não há dados</span>
                </div>
              )}
            </div>
          ) : (
            <div className="form-success">
              <Spinner size="large" color="primary" />
            </div>
          )}
        </div>
      )}

      {addBeneficiary && (
        <div className="beneficiary-form-container" style={{ position: 'fixed', zIndex: 1000, top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ background: 'white', borderRadius: 12, padding: 24, minWidth: 280, maxWidth: 350, width: '90%', boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
            <div className="add-beneficiary-header" style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span className="header-text">Adicionar Beneficiário</span>
              <button className="button-back" onClick={() => { setAddBeneficiary(false); setUser(null); }} style={{ background: 'none', border: 'none', fontSize: 22 }}>
                <MdClose />
              </button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <Input
                label="Nome"
                value={user.name}
                onChange={e => setUser({ ...user, name: e.target.value })}
                placeholder="Digite o nome"
                autoFocus
              />
              <Input
                label="E-mail"
                value={user.email}
                onChange={e => setUser({ ...user, email: e.target.value })}
                placeholder="Digite o e-mail"
                type="email"
              />
              <Input
                label="Telefone"
                value={user.phone}
                onChange={e => setUser({ ...user, phone: e.target.value })}
                placeholder="Digite o telefone"
                type="tel"
              />
              <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
                <Button label="Cancelar" variant="ghost" color="gray" handleClick={() => { setAddBeneficiary(false); setUser(null); }} />
                <Button label="Salvar" color="orange" handleClick={() => { setAddBeneficiary(false); }} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MobileFormScreen

/* 
<div>
  <Lottie options={defaultLottieOptions} height={300} width={300} />
  <p className="form-title">Link gerado com sucesso!</p>
</div>
<Button
  handleClick={goToHome}
  // variant="ghost"
  // color="orange"
  label="Voltar para tela inicial"
/>
*/

function truncateString(str) {
  if (str.length > 25) {
    return str.substring(0, 25) + "..."
  }
  return str
}
